import React from 'react';

const StudioRightProperties = ({ children }) => (
  <aside className="studio-sidebar studio-sidebar-right">
    {children ? children : (
      <>
        <div className="studio-sidebar-title">Right Properties</div>
        <div className="studio-sidebar-placeholder">Inspector</div>
      </>
    )}
  </aside>
);

export default StudioRightProperties;
